/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { FrotasService } from "../shared/frota.service";
import { FrotaNavigationService } from "../shared/frota-navigation.service";
import { FrotaApiService } from "../shared/frota-api.service";
import { OdometroHorimetroApiService } from "../../../manutencoes/odometros-horimetros/shared/odometro-horimetro-api.service";
import { FormaControleService } from "../../formas-controle/shared/forma-controle.service";

@Component({
    template: require('./frota-odometro-horimetro.component.html'),
    styles: [require('./frota-odometro-horimetro.component.css')]
})
export class FrotaOdometroHorimetroComponent implements OnInit {
    frotasModule: any = {};
    thisRoute:string = '';
    detail: any = {};
    list: any[] = [];
    loading: boolean = true;
    isOdometro: boolean = false;

    private moduleId: number;

    constructor(
        private _frotaService: FrotasService,
        private _frotaNavigationService: FrotaNavigationService,
        private _frotaApiService: FrotaApiService,
        private _odometroHorimetroApiService: OdometroHorimetroApiService,
        private _formaControleService: FormaControleService,
        private _route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.frotasModule = this._frotaService.getModuleName();
        this.thisRoute = this._frotaService.getRouteName();
        this.moduleId = this._frotaService.getModuleId();

        let id = +this._route.snapshot.params['id'];
        this.getObject(id);
        this.getAll(id);
    }

    clickGoToList() {
        this._frotaNavigationService.goToList(this.thisRoute);
    }

    clickGoToDetail() {
        this._frotaNavigationService.goToDetail(this.detail.id, this.thisRoute);
    }

    private getObject(id: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                const storage = this._frotaService.getSessionStorage();
                if (storage) {
                    Response.Combustiveis = storage.Combustiveis;
                }
                this.detail = Response;

                let y: any = this._formaControleService.getFormaControleOdometro();
                if (Response.formaControleId === y) {
                    this.isOdometro = true;
                }

            } else {
                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._frotaApiService.onGetById(id, onDone);
    }

    private getAll(id: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
                this.loading = false;
            }
        }.bind(this));

        this._odometroHorimetroApiService.onGetByBem(id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frota-odometro-horimetro/frota-odometro-horimetro.component.ts
 **/